module.exports = __webpack_public_path__ + "static/clientreview-a30bda1e99b77343d4c76d452c208424.png";